import { ViewTypeChartEnum } from "../../Shared/ViewTypeChartEnum"
import { AssessmentTypeTextEnum } from "../../../../../../lms-shared/models/AssessmentTypeEnum";


const StoryLineReport = {

    [AssessmentTypeTextEnum.ClosedText]: {
        converSultion: (submission) => {
            return submission.solution;
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    },
    [AssessmentTypeTextEnum.OpenText]: {
        converSultion: (submission) => {
            return submission.solution;
        },
        graph: {
            dataType: ViewTypeChartEnum.RightAndWrongAnser
        }
    },
    [AssessmentTypeTextEnum.MultyChoice]: {

        converSultion: (submission) => {
            let fullSolution
            const extractContent = (s) => {
                var span = document.createElement('span');
                span.innerHTML = s;
                return span.textContent || span.innerText;
            }
            if (submission.solution) {
                const assessmentContentData = JSON.parse(submission.assessmentContentData)
                let answers = JSON.parse(submission.solution)
                let innerText
                fullSolution = ''
                answers.forEach(a => {
                    innerText = extractContent(assessmentContentData.Data.options[a - 1]?.content)
                    fullSolution = fullSolution + ` ${a} . ${innerText}`
                })
            }

            return fullSolution;
        },
        graph: {
            dataType: ViewTypeChartEnum.DetailAnswer
        }
    },
    [AssessmentTypeTextEnum.Choice]: {
        converSultion: (submission) => {
            let fullSolution
            if (submission.solution) {
                const assessmentContentData = JSON.parse(submission.assessmentContentData)
                let index = JSON.parse(submission.solution);
                var span = document.createElement('span');
                span.innerHTML = assessmentContentData.Data.options[index - 1]?.content;
                let innerText = span.textContent || span.innerText;
                if (innerText != 'undefined')
                    fullSolution = ` ${index} . ${innerText}`
            }

            return fullSolution;
        },
        graph: {
            dataType: ViewTypeChartEnum.DetailAnswer
        }
    },

}
export default StoryLineReport